module.exports = __webpack_public_path__ + "static/media/short_text.39a50ea2.svg";